// Closed-admission function handles (bead hf-e9-clerk-identity-xnf.2).
//
// Only allowlist administration is browser-callable here. The admission decision is
// an internal mutation: xnf.3's authenticated invitation flow will call it without
// accepting a browser-supplied identifier.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

export const admissionAllowlistQuery = api.domain.admission.listAllowlist;
export const addAdmissionEmailMutation = api.domain.admission.addEmail;
export const removeAdmissionEntryMutation = api.domain.admission.removeEntry;

export type AdmissionAllowlistResult = FunctionReturnType<typeof admissionAllowlistQuery>;
